import axiosInstance from "./axiosInstance";

// ── Shipping Profiles ────────────────────────────────────────────────────────

export const getShippingProfiles = (params = {}) =>
  axiosInstance.get("/shipping-profiles/", { params });

export const getShippingProfile = (id) =>
  axiosInstance.get(`/shipping-profiles/${id}/`);

export const createShippingProfile = (data) =>
  axiosInstance.post("/shipping-profiles/", data);

export const updateShippingProfile = (id, data) =>
  axiosInstance.patch(`/shipping-profiles/${id}/`, data);

export const deleteShippingProfile = (id) =>
  axiosInstance.delete(`/shipping-profiles/${id}/`);

// bulk = استبدال/تحديث كل أسعار المحافظات للـ profile ده دفعة واحدة
export const saveShippingProfileRates = (id, rates) =>
  axiosInstance.post(`/shipping-profiles/${id}/rates/bulk/`, rates);